// Credits: borrowed code from fcomb/redux-logger

import { deepCopy } from "../index.js";

export let c_CBOrigConsoleLog = window.console.log;

const c_bIsConsoleLogOn = true; // disable/enable standard console logging

function G_ConsoleLogSwitch() {
  c_CBOrigConsoleLog = window.console.log;

  if (!c_bIsConsoleLogOn) {
    if (window.console) {
      var arConsoleMethods = [
        "log",
        /* "error", */ "debug",
        "warn",
        "info",
        "trace",
        "time",
        "timeEnd",
        "timeStamp",
        "timeLog",
        "assert",
        "dir",
        "group",
        "groupEnd",
        "profile",
        "profileEnd",
        "table"
      ];

      for (let idx = 0; idx < arConsoleMethods.length; idx++) {
        if (
          window.console[arConsoleMethods[idx]] !== null &&
          window.console[arConsoleMethods[idx]] !== undefined
        ) {
          window.console[arConsoleMethods[idx]] = function() {};
        }
      }
    }
  }
}

export default function createLogger({
  collapsed = true,
  transformer = state => state,
  mutationTransformer = mut => mut
} = {}) {
  G_ConsoleLogSwitch();

  return store => {
    let prevState = deepCopy(store.state);

    store.subscribe((mutation, state) => {
      if (typeof console === "undefined") {
        return;
      }
      const nextState = deepCopy(state);
      const time = new Date();
      const formattedTime = ` @ ${pad(time.getHours(), 2)}:${pad(
        time.getMinutes(),
        2
      )}:${pad(time.getSeconds(), 2)}.${pad(time.getMilliseconds(), 3)}`;
      const formattedMutation = mutationTransformer(mutation);
      const message = `mutation ${mutation.type}${formattedTime}`;
      const startMessage = collapsed ? console.groupCollapsed : console.group;

      // render
      try {
        if (c_bIsConsoleLogOn) {
          startMessage.call(console, message);
        }
      } catch (e) {
        console.log(message);
      }

      if (c_bIsConsoleLogOn) {
        console.log(
          "%c prev state",
          "color: #9E9E9E; font-weight: bold",
          transformer(prevState)
        );
        console.log(
          "%c mutation",
          "color: #03A9F4; font-weight: bold",
          formattedMutation
        );
        console.log(
          "%c next state",
          "color: #4CAF50; font-weight: bold",
          transformer(nextState)
        );
      }

      try {
        if (c_bIsConsoleLogOn) {
          console.groupEnd();
        }
      } catch (e) {
        console.log("—— log end ——");
      }

      prevState = nextState;
    });
  };
}

function repeat(str, times) {
  return new Array(times + 1).join(str);
}

function pad(num, maxLength) {
  return repeat("0", maxLength - num.toString().length) + num;
}
